var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06306 5.94594C4.65523 5.94594 5.94594 4.65523 5.94594 3.06306C5.94594 1.47089 4.65523 0.180176 3.06306 0.180176C1.47089 0.180176 0.180176 1.47089 0.180176 3.06306C0.180176 4.65523 1.47089 5.94594 3.06306 5.94594Z",
    stroke: "#845EFF",
    strokeWidth: 0.36036
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06299 1.80176V3.2432V1.80176Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06299 1.80176V3.2432",
    stroke: "#845EFF",
    strokeWidth: 0.540541,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.063 4.86476C3.26202 4.86476 3.42336 4.70342 3.42336 4.5044C3.42336 4.30538 3.26202 4.14404 3.063 4.14404C2.86398 4.14404 2.70264 4.30538 2.70264 4.5044C2.70264 4.70342 2.86398 4.86476 3.063 4.86476Z",
    fill: "#845EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.34b1f68af7866eede7d232337805e4b3.svg";
export { ForwardRef as ReactComponent };